import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Navbar from '../../../components/organism/navbar/index.tsx'
import './index.css'
import Badge from 'react-bootstrap/esm/Badge'
import MarketingSeo from '../../../components/marketingSeo/index.tsx'

const DemoHr : React.FC = () => {
	const { t, i18n } = useTranslation('demo')
	const LEAFLET_FILENAMES: Record<string, string> = { hr: 'hr', en: 'en', de: 'de', sl: 'sl', sr: 'sr', bs: 'bh' }
	const leafletCode = LEAFLET_FILENAMES[i18n.language] || 'hr'
	const leafletSrc = `/assets/leaflets/leaflet-${leafletCode}.svg`
	// run this function from an event handler or an effect to execute scroll
	useEffect(() => {
		// if (loaderShown) {
		document.querySelector('.body-container')?.classList.add('position-initial')
		// }

		setTimeout(() => {
			window.scrollTo({ top: 0 })
		}, 200)
	}, [])

	return (
		<div className='body-container'>
			<MarketingSeo page='demo' />
			<Navbar scrollToContact={() => {}} />
			<div className='demo-content demo-grid'>
				<div className='demo-content-row demo-row'>
					<h1 className='demo-page-title'>{t('title')}</h1>
					<div style={{ marginBottom: 20, textAlign: 'left', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>

						<p><b>{t('instructions.title')}</b></p>
						<ol>
							<li><p>{t('instructions.step1')}</p></li>
							<li><p>{t('instructions.step2')}</p></li>
							<li><p>{t('instructions.step3')}</p></li>
						</ol>
					</div>

					<h3 style={{ textAlign: 'center', paddingBottom: 10 }}>{t('wedding.title')}</h3>

					<div className='demo-row-content'>
						<h2>{t('wedding.status')}</h2>
						<Badge bg='success'>{t('wedding.statusActive')}</Badge>
					</div>

					<div className='demo-row-content'>
						<h2>{t('wedding.pin')}</h2>
						<p><b>51310835</b></p>
					</div>

					<div className='demo-row-content'>
						<h2>{t('wedding.startDate')}</h2>
						<p>23.12.2024.</p>
					</div>

					<div className='demo-row-content'>
						<h2>{t('wedding.endDate')}</h2>
						<p>{t('wedding.unlimited')}</p>
					</div>

					<div className='demo-row-content'>
						<h2>{t('wedding.maxGuests')}</h2>
						<p>{t('wedding.unlimited')}</p>
					</div>

					<div className='demo-row-content'>
						<h2>{t('wedding.imagesPerGuest')}</h2>
						<p>2</p>
					</div>

					<div className='demo-row-content'>
						<h2>{t('wedding.galleryLink')}</h2>
						<p><i>{t('wedding.galleryNotReady')}</i></p>
					</div>

				</div>
				<div className='demo-flyer-container demo-row'>
					<img src={leafletSrc} alt='Demo leaflet' />
					<div className='app-store-buttons'>
						<a href='https://apps.apple.com/us/app/id6608982445' target='_blank' rel='noopener noreferrer'>
							<img className='badge-apple' src='/assets/badges/app-store-badge.svg' alt='Download on App Store' />
						</a>
						<a href='https://play.google.com/store/apps/details?id=com.mcode.weddingcam' target='_blank' rel='noopener noreferrer'>
							<img className='badge-google' src='/assets/badges/google-play-badge.png' alt='Get it on Google Play' />
						</a>
					</div>
				</div>
			</div>
			{/* <Footer /> */}
		</div>
	)
}

export default DemoHr
